import { Pipe, PipeTransform } from '@angular/core';
import { FieldOfUse } from '../../../types/sample/FieldOfUse';

@Pipe({
    name: 'fieldOfUseSeverity',
    standalone: true,
})
export class FieldOfUseSeverityPipe implements PipeTransform {
    transform(fieldOfUse: FieldOfUse | undefined): 'success' | 'secondary' | 'info' | 'warn' | 'danger' | 'contrast' | undefined {
        switch (fieldOfUse) {
            case FieldOfUse.INTERIOR:
                return 'info';
            case FieldOfUse.EXTERIOR:
                return 'warn';
            default:
                return undefined;
        }
    }
}
